import React from "react";
import cn from "classnames";

import {capitalize} from "@pg-mono/nodash";

import {usePillIndicator} from "../hooks/use_pill_indicator";
import type {ITab} from "../types/ITab";
import type {TabsActiveColor} from "../types/TabsActiveColor";
import type {TabsAllowedValueTypes} from "../types/TabsAllowedValueTypes";
import type {TabsTheme} from "../types/TabsTheme";
import {Title} from "./Title";

import * as styles from "./Tabs.module.css";

type ClassName = keyof typeof styles;

const getTilesPillTheme = (theme: TabsTheme) => `tilesPill${capitalize(theme)}` as ClassName;

interface IProps<ValueType extends TabsAllowedValueTypes> {
    activeColor?: TabsActiveColor;
    customRenderer?: (tab: ITab<ValueType>, titleElement: React.ReactNode, index: number) => React.ReactNode;
    fullWidth?: boolean;
    onChange?: (value: ValueType) => void;
    onTabClick: (tab: ITab<ValueType>) => void;
    tabs: ITab<ValueType>[];
    theme: TabsTheme;
    titleClassName?: string;
    value?: ValueType;
}

export const PillTabsTiles = <ValueType extends TabsAllowedValueTypes>(props: IProps<ValueType>) => {
    const {activeColor, customRenderer, fullWidth, onChange, onTabClick, tabs, theme, titleClassName, value} = props;

    const activeIndex = typeof value !== "undefined" ? tabs.findIndex((tab) => tab.value === value) : -1;
    const {containerRef, indicatorStyle, isAnimated, isIndicatorReady, setTabRef} = usePillIndicator(activeIndex);

    return (
        <div
            ref={containerRef}
            className={cn(styles.tiles, fullWidth && styles.wFull, styles.tilesPill, styles[getTilesPillTheme(theme)])}
            data-indicator-ready={isIndicatorReady ? "true" : "false"}
        >
            <div
                aria-hidden
                className={cn(styles.pillIndicator, isAnimated && styles.pillIndicatorAnimated)}
                style={{
                    height: indicatorStyle.height,
                    transform: `translate(${indicatorStyle.left}px, ${indicatorStyle.top}px)`,
                    width: indicatorStyle.width
                }}
            />

            {tabs.map((tab, index) => {
                const active = typeof value !== "undefined" ? value === tab.value : false;

                const titleElement = (
                    <Title
                        active={active}
                        activeColor={activeColor}
                        className={titleClassName}
                        dataTestId={tab.dataTestId}
                        fullWidth={fullWidth}
                        href={tab.href}
                        interceptHrefNavigation={Boolean(onChange && tab.href)}
                        onClick={tab.href && !onChange ? undefined : () => onTabClick(tab)}
                        theme={theme}
                        variant="pill"
                    >
                        {tab.title}
                    </Title>
                );

                return (
                    <div
                        key={tab.value}
                        ref={setTabRef(index)}
                        className={cn(
                            styles.pillTabItem,
                            fullWidth && styles.pillTabItemFullWidth,
                            active && !isIndicatorReady && styles.pillTabItemActiveFallback
                        )}
                    >
                        {customRenderer ? customRenderer(tab, titleElement, index) : titleElement}
                    </div>
                );
            })}
        </div>
    );
};
import React from "react";
import cn from "classnames";

import {capitalize} from "@pg-mono/nodash";

import {usePillIndicator} from "../hooks/use_pill_indicator";
import type {ITab} from "../types/ITab";
import type {TabsActiveColor} from "../types/TabsActiveColor";
import type {TabsAllowedValueTypes} from "../types/TabsAllowedValueTypes";
import type {TabsTheme} from "../types/TabsTheme";
import {Title} from "./Title";

import * as styles from "./Tabs.module.css";

type ClassName = keyof typeof styles;

const getTilesPillTheme = (theme: TabsTheme) => `tilesPill${capitalize(theme)}` as ClassName;

interface IProps<ValueType extends TabsAllowedValueTypes> {
    activeColor?: TabsActiveColor;
    customRenderer?: (tab: ITab<ValueType>, titleElement: React.ReactNode, index: number) => React.ReactNode;
    fullWidth?: boolean;
    onChange?: (value: ValueType) => void;
    onTabClick: (tab: ITab<ValueType>) => void;
    tabs: ITab<ValueType>[];
    theme: TabsTheme;
    titleClassName?: string;
    value?: ValueType;
}

export const PillTabsTiles = <ValueType extends TabsAllowedValueTypes>(props: IProps<ValueType>) => {
    const {activeColor, customRenderer, fullWidth, onChange, onTabClick, tabs, theme, titleClassName, value} = props;

    const activeIndex = typeof value !== "undefined" ? tabs.findIndex((tab) => tab.value === value) : -1;
    const {containerRef, indicatorStyle, isAnimated, isIndicatorReady, setTabRef} = usePillIndicator(activeIndex);

    return (
        <div
            ref={containerRef}
            className={cn(styles.tiles, fullWidth && styles.wFull, styles.tilesPill, styles[getTilesPillTheme(theme)])}
            data-indicator-ready={isIndicatorReady ? "true" : "false"}
        >
            <div
                aria-hidden
                className={cn(styles.pillIndicator, isAnimated && styles.pillIndicatorAnimated)}
                style={{
                    height: indicatorStyle.height,
                    transform: `translate(${indicatorStyle.left}px, ${indicatorStyle.top}px)`,
                    width: indicatorStyle.width
                }}
            />

            {tabs.map((tab, index) => {
                const active = typeof value !== "undefined" ? value === tab.value : false;

                const titleElement = (
                    <Title
                        active={active}
                        activeColor={activeColor}
                        className={titleClassName}
                        dataTestId={tab.dataTestId}
                        fullWidth={fullWidth}
                        href={tab.href}
                        interceptHrefNavigation={Boolean(onChange && tab.href)}
                        onClick={tab.href && !onChange ? undefined : () => onTabClick(tab)}
                        theme={theme}
                        variant="pill"
                    >
                        {tab.title}
                    </Title>
                );

                return (
                    <div
                        key={tab.value}
                        ref={setTabRef(index)}
                        className={cn(
                            styles.pillTabItem,
                            fullWidth && styles.pillTabItemFullWidth,
                            active && !isIndicatorReady && styles.pillTabItemActiveFallback
                        )}
                    >
                        {customRenderer ? customRenderer(tab, titleElement, index) : titleElement}
                    </div>
                );
            })}
        </div>
    );
};
